import { render, staticRenderFns } from "./LoadingCompatibility.vue?vue&type=template&id=5a3ca565&scoped=true"
import script from "./LoadingCompatibility.vue?vue&type=script&lang=js"
export * from "./LoadingCompatibility.vue?vue&type=script&lang=js"
import style0 from "./LoadingCompatibility.vue?vue&type=style&index=0&id=5a3ca565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ca565",
  null
  
)

export default component.exports